import React from 'react';
import Layout from '../../components/Layout';
import Occasion from './Occasion';
import { OCCASIONS_PATH } from '../../constants';
import { urlPrefix } from '../../helpers';
import { getOccasion } from '../../actions/shop';

async function action({ store }, { id, occasion }) {
  const {
    config: { occasions = {} },
    intl: { countryCode, locale, currency },
  } = store.getState();

  if (!occasions[id]) {
    return undefined;
  }

  const {
    label,
    categoryDescription,
    categoryLogo,
    categoryMetaDescription,
    categoryMetaTitle,
    categorySlug,
  } = occasions[id];

  const redirect =
    categorySlug !== occasion
      ? urlPrefix(`${OCCASIONS_PATH}/${categorySlug}/${id}`, {
          locale,
          countryCode,
          currency,
        })
      : undefined;

  await store.dispatch(getOccasion(id));

  return {
    chunks: ['occasion'],
    title: categoryMetaTitle || label,
    description: categoryMetaDescription || categoryDescription,
    component: (
      <Layout footerBar>
        <Occasion
          id={id}
          title={label}
          content={categoryDescription || 'Missing categoryDescription'}
          image={categoryLogo}
        />
      </Layout>
    ),
    redirect,
    addCompanyMarkup: true,
  };
}

export default action;
